module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image9.c26af8dc.jpg";